/*! SuperfluidLayout | MIT License | https://github.com/codrops/SuperfluidLayout */

import SplitType from "split-type";
import { gsap } from "gsap";
import { wrapLines } from "./utils";

export class TextLinesReveal {
  DOM: { animationElems: Array<HTMLElement | null> };
  SplitTypeInstances: SplitType[];
  words: Array<HTMLElement[]>;
  isVisible: boolean;
  constructor(animationElems: Array<HTMLElement | null>) {
    this.DOM = {
      animationElems: Array.isArray(animationElems)
        ? animationElems
        : [animationElems],
    };

    // array of SplitType instances
    this.SplitTypeInstances = [];
    // array of all HTML .line
    this.words = [];

    for (const el of this.DOM.animationElems) {
      // @ts-ignore
      const SplitTypeInstance = new SplitType(el, { types: "words" });
      // wrap the words (div with class .oh)
      // the inner child will be the one animating the transform
      if (SplitTypeInstance.words) {
        wrapLines(SplitTypeInstance.words, "span", "oh");
        this.words.push(SplitTypeInstance.words);
      }
      // keep a reference to the SplitType instance
      this.SplitTypeInstances.push(SplitTypeInstance);
    }

    this.initEvents();
  }
  in() {
    // words are visible
    this.isVisible = true;

    // animation
    gsap.killTweensOf(this.words);
    return gsap
      .timeline({ defaults: { duration: 1.2, ease: "expo" } })
      .set(this.words, {
        y: "100%",
        rotate: 15,
        opacity: 0,
      })
      .to(this.words, {
        y: "0%",
        rotate: 0,
        opacity: 1,
        stagger: 0.04,
      });
  }
  out() {
    // words are invisible
    this.isVisible = false;

    // animation
    gsap.killTweensOf(this.words);
    return gsap
      .timeline({
        defaults: { duration: 0.7, ease: "power2" },
      })
      .to(this.words, {
        y: "-10%",
        opacity: 0,
        rotate: -5,
        stagger: 0.02,
      });
  }
  initEvents() {
    window.addEventListener("resize", () => {
      // empty the words array
      this.words = [];
      // re initialize the Split Text
      for (const instance of this.SplitTypeInstances) {
        // re-split text
        // https://github.com/lukePeavey/SplitType#instancesplitoptions-void
        instance.split({ types: "words" });

        // need to wrap again the new words elements (div with class .oh)
        if (instance.words) {
          wrapLines(instance.words, "span", "oh");
          this.words.push(instance.words);
        }
      }
      // hide the words
      if (!this.isVisible) {
        gsap.set(this.words, { y: "-150%", opacity: 0 });
      }
    });
  }
}
